'use strict';
import DispoHelpers from './dispoHelpers';
import Gift from '../checkout/gift';
/**
 * @param {Object} defer - the deferred object which will resolve on success or reject.
 * @param {Object} data - the response data with the invalid form fields or
 */

function updateGiftingInformation (defer, data) {
    if (data.html) {
        if (!DispoHelpers.isDispoActive()) {
            $('.checkout-product-summary')[0].outerHTML = data.html;
            $('.checkout-product-summary').addClass('cc-checkoutProductSummaryDispo');
        } else {
            $('.orderProductWrapper').html(data.html);
            $('.wrapper-gift-container').addClass('hidden');
            if (data.isBopis !== 'true' && data.isBopis !== true) {
                var wrapperGiftContainer = $('.wrapper-gift-container').html();
                $('.js-shipping-method-summary-days').html(data.maxInterval);
                $('.copy-wrapper-gift-container').html(wrapperGiftContainer);
                Gift.run();
            }
            DispoHelpers.run();
            data.order.totals.longDistanceTotalPrice != null ? $('.long-distance-message').removeClass('hide') : $('.long-distance-message').addClass('hide');
            $('.data-checkout-stage').attr('data-express-flow') === 'true' ? $('.js-remove-external-items-modal').addClass('hide') : $('.js-remove-external-items-modal').removeClass('hide');
        }
    }

    var expressMethodEnabled = true;
    var defaultApplePayMethod = true;
    var wrappedQuantity = 0;
    var giftKitQuantity = 0;
    var isNoSpliced = $('.noSpliced').length > 0;

    if (data.order) {
        if (data.order.items) {
            const orderItems = data.order.items.items;
            for (let item of orderItems) {
                if (!item.wrappedQuantity || item.wrappedQuantity === 0) {
                    $('.js-gifting-container-' + item.UUID).hide();
                } else {
                    wrappedQuantity++;
                    expressMethodEnabled = false;
                    $('.js-gifting-container-' + item.UUID).show();
                    $('.js-wrapped-quantity-' + item.UUID).html(item.wrappedQuantity);
                    if ($('#isDispoCountry').val() !== 'false') {
                        var addedWrapItems = $('.chosen-gift-box').parents('.copy-wrapper-gift-container').attr('data-addedwrapitems') || '';
                        $('.chosen-gift-box').parents('.copy-wrapper-gift-container').attr('data-addedwrapitems', addedWrapItems + ',' + item.UUID);
                    }
                }
                if (item.isGiftKit) {
                    giftKitQuantity++;
                    expressMethodEnabled = false;
                    if ($('#isDispoCountry').val() !== 'false') {
                        $('.chosen-gift-box').parents('.copy-wrapper-gift-container').attr('data-addedkititems', 'true');
                    }
                }
            }
        }
        const shipment = data.order.shipping;
        if (shipment && shipment.length > 0) {
            if (!shipment[0].selectedShippingMethod.isApplePayEnabled) {
                defaultApplePayMethod = false;
            }
        }
    }
    if (DispoHelpers.isDispoActive()) {
        DispoHelpers.giftOptionsLabel();
    } else {
        // Display the selected label according to the states of the gifts.
        if (wrappedQuantity === 0 && giftKitQuantity > 0) {
            $('.chosen-gift-box').siblings('.js-wrapperGiftContainer-giftKitNotWrapped').removeClass('hide');
            $('.chosen-gift-box').siblings('.js-wrapperGiftContainer-wrappedNoGiftkit').addClass('hide');
            $('.chosen-gift-box').siblings('.js-wrapperGiftContainer-wrappedGiftkit').addClass('hide');
        } else if (wrappedQuantity > 0 && giftKitQuantity === 0) {
            $('.chosen-gift-box').siblings('.js-wrapperGiftContainer-giftKitNotWrapped').addClass('hide');
            $('.chosen-gift-box').siblings('.js-wrapperGiftContainer-wrappedNoGiftkit').removeClass('hide');
            $('.chosen-gift-box').siblings('.js-wrapperGiftContainer-wrappedGiftkit').addClass('hide');
        } else if (wrappedQuantity > 0 && giftKitQuantity > 0) {
            $('.chosen-gift-box').siblings('.js-wrapperGiftContainer-giftKitNotWrapped').addClass('hide');
            $('.chosen-gift-box').siblings('.js-wrapperGiftContainer-wrappedNoGiftkit').addClass('hide');
            $('.chosen-gift-box').siblings('.js-wrapperGiftContainer-wrappedGiftkit').removeClass('hide');
        } else {
            $('.chosen-gift-box').siblings('.js-wrapperGiftContainer-giftKitNotWrapped').addClass('hide');
            $('.chosen-gift-box').siblings('.js-wrapperGiftContainer-wrappedNoGiftkit').addClass('hide');
            $('.chosen-gift-box').siblings('.js-wrapperGiftContainer-wrappedGiftkit').addClass('hide');
        }
    }

    // Toggle gift wrap button area
    if ($('#isDispoCountry').val() !== 'false' && !isNoSpliced) {
        $('.section-selected .js-wrap-buttons').toggleClass('hide', wrappedQuantity > 0);
        $('.section-selected .js-wrap-links').toggleClass('hide', wrappedQuantity === 0);
    } else {
        $('.js-wrap-buttons').toggleClass('hide', wrappedQuantity > 0);
        $('.js-wrap-links').toggleClass('hide', wrappedQuantity === 0);
    }
    if (wrappedQuantity > 0) {
        $('.cc-giftWrapOption').addClass('hide');
    } else {
        $('.cc-giftWrapOption').removeClass('hide');
    }
    // Toggle gift kit button area
    $('.js-kit-buttons').toggleClass('hide', giftKitQuantity > 0);
    $('.js-kit-links').toggleClass('hide', giftKitQuantity === 0);
    if (giftKitQuantity > 0) {
        $('.cc-giftKitOption').addClass('hide');
    } else {
        $('.cc-giftKitOption').removeClass('hide');
    }
    if (expressMethodEnabled) {
        $('.js-paypal-container').removeClass('disabled');
        $('.js-amazon-pay-container').removeClass('disabled');
        $('.js-google-pay-container').removeClass('disabled');
        // if the shipping method selected is not the default courier, applePay button should be disabled
        if (defaultApplePayMethod) {
            $('.js-apple-pay-container').removeClass('disabled');
        } else {
            $('.js-apple-pay-container').addClass('disabled');
        }
    } else {
        $('.js-paypal-container').addClass('disabled');
        $('.js-apple-pay-container').addClass('disabled');
        $('.js-amazon-pay-container').addClass('disabled');
        $('.js-google-pay-container').addClass('disabled');
    }
}

function resetGiftCardForm () {
    const $drawer = $('.giftCardDrawer');
    $drawer.find('.giftcard-amount-feedback').addClass('hidden');
    $drawer.find('.giftcardModalBlock').removeClass('hidden');
    $drawer.find('.buttonRemoveGiftcard').addClass('hide');
    $drawer.find('.js-controlCardButtons').removeClass('hide');
    $drawer.find('.js-recaptcha').removeClass('hide');
    $drawer.find('.buttonApplyGiftcard').addClass('disabled');
}

module.exports = {
    updateGiftingInformation: updateGiftingInformation,
    resetGiftCardForm: resetGiftCardForm
};
